import React from 'react';

const statusColors = {
  draft: 'bg-gray-100 text-gray-700 border-gray-200',
  active: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  suspended: 'bg-amber-100 text-amber-800 border-amber-200',
  removed: 'bg-gray-100 text-gray-500 border-gray-200',
  submitted: 'bg-blue-100 text-blue-800 border-blue-200',
  under_review: 'bg-amber-100 text-amber-800 border-amber-200',
  approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  rejected: 'bg-red-100 text-red-800 border-red-200',
  paid: 'bg-green-100 text-green-800 border-green-200',
  validated: 'bg-blue-100 text-blue-800 border-blue-200',
  signed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  terminated: 'bg-red-100 text-red-800 border-red-200',
  issued: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  revoked: 'bg-red-100 text-red-800 border-red-200',
};

export function CmcStatusBadge({ status, label }) {
  const cls = statusColors[status] || 'bg-gray-100 text-gray-700 border-gray-200';
  return (
    <span
      data-testid={`cmc-status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium ${cls}`}
    >
      {label || status || '-'}
    </span>
  );
}

import { Coin as CoinIcon, MagnifyingGlass, HandCoins, FileText, Users, Bank, Certificate, Gavel, Handshake, Factory } from '@phosphor-icons/react';
import { PageHero } from '../motion/PageHero';

export function CmcPageHeader({ title, subtitle, actions, icon, gradient, accents }) {
  // Détection auto de la palette + icône selon la page CMC
  const t = (title || '').toLowerCase();
  let autoGrad = 'from-[#2D5A4C] to-[#1E4136]';
  let autoAccents = ['#00AEEF', '#80C51F'];
  let AutoIcon = CoinIcon;
  if (t.includes('audit')) { autoGrad = 'from-[#5E6D66] to-[#1E4136]'; autoAccents = ['#EA3C3A', '#00AEEF']; AutoIcon = MagnifyingGlass; }
  else if (t.includes('paiement') || t.includes('payment')) { autoGrad = 'from-[#FF8E00] to-[#D5007D]'; autoAccents = ['#80C51F', '#00AEEF']; AutoIcon = HandCoins; }
  else if (t.includes('contrat') || t.includes('contract')) { autoGrad = 'from-[#00AEEF] to-[#2D5A4C]'; autoAccents = ['#80C51F', '#FF8E00']; AutoIcon = FileText; }
  else if (t.includes('coopérat') || t.includes('cooperator')) { autoGrad = 'from-[#80C51F] to-[#2D5A4C]'; autoAccents = ['#00AEEF', '#FF8E00']; AutoIcon = Users; }
  else if (t.includes('attest')) { autoGrad = 'from-[#D5007D] to-[#EA3C3A]'; autoAccents = ['#FF8E00', '#00AEEF']; AutoIcon = Certificate; }
  else if (t.includes('ucc')) { autoGrad = 'from-[#00AEEF] to-[#1E4136]'; autoAccents = ['#D5007D', '#80C51F']; AutoIcon = Bank; }
  else if (t.includes('règle') || t.includes('rule')) { autoGrad = 'from-[#1E4136] to-[#2D5A4C]'; autoAccents = ['#FF8E00', '#00AEEF']; AutoIcon = Gavel; }
  else if (t.includes('convention') || t.includes('cipaesse') || t.includes('cipasco')) { autoGrad = 'from-[#2D5A4C] to-[#00AEEF]'; autoAccents = ['#80C51F', '#D5007D']; AutoIcon = Handshake; }
  else if (t.includes('apport')) { autoGrad = 'from-[#FF8E00] to-[#2D5A4C]'; autoAccents = ['#80C51F', '#D5007D']; AutoIcon = Factory; }

  return (
    <PageHero
      title={title}
      subtitle={subtitle}
      icon={icon || <AutoIcon size={24} weight="duotone" className="text-white" />}
      gradient={gradient || autoGrad}
      accents={accents || autoAccents}
      actions={actions}
    />
  );
}

export function CmcEmpty({ icon: Icon, message, hint }) {
  return (
    <div className="py-16 text-center" data-testid="cmc-empty">
      {Icon && <Icon size={36} className="mx-auto text-[#C5C0B6] mb-3" />}
      <p className="text-sm text-[#5E6D66] font-medium">{message}</p>
      {hint && <p className="text-xs text-[#8DB0A1] mt-1">{hint}</p>}
    </div>
  );
}

export function fmtAmount(n, currency = 'EUR') {
  if (n === null || n === undefined) return '-';
  try {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(Number(n));
  } catch {
    return `${n} ${currency}`;
  }
}

export function fmtDate(s) {
  if (!s) return '-';
  try {
    return new Date(s).toLocaleString('fr-FR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return s;
  }
}

export function fmtDateOnly(s) {
  if (!s) return '-';
  try {
    return new Date(s).toLocaleDateString('fr-FR');
  } catch {
    return s;
  }
}
